import { render, staticRenderFns } from "./GruposDeOpcionais.vue?vue&type=template&id=714be981"
import script from "./GruposDeOpcionais.vue?vue&type=script&lang=js"
export * from "./GruposDeOpcionais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports